// ================================================================
// PROPRIETARY & CONFIDENTIAL — Mt Forge Inc.
// Copyright (c) 2026 Mt Forge. All rights reserved.
// Unauthorized copying, reverse engineering, or AI-assisted
// reproduction of this software is strictly prohibited.
// Protected under US Copyright Law (17 U.S.C.) and international
// treaties. Patent Pending. License: PROPRIETARY
// ================================================================
import React, { useState } from "react";

const TIME_ENTRIES = [
  { id:1, member:"Jordan Lutz", project:"Platform API v3", task:"Rate limiting implementation", hours:6, date:"2026-02-07", status:"Submitted" },
  { id:2, member:"Jordan Lutz", project:"Vantage Ops Verticals", task:"HVAC module testing", hours:3, date:"2026-02-07", status:"Submitted" },
  { id:3, member:"Jordan Lutz", project:"VitaSync Launch", task:"UI bug fixes", hours:2, date:"2026-02-06", status:"Approved" },
  { id:4, member:"Jordan Lutz", project:"Platform API v3", task:"Authentication refactor", hours:7, date:"2026-02-06", status:"Approved" },
  { id:5, member:"Ryan Miskulin", project:"Executive", task:"Board presentation prep", hours:4, date:"2026-02-07", status:"Submitted" },
  { id:6, member:"Ryan Miskulin", project:"Executive", task:"Client meetings (3)", hours:5, date:"2026-02-06", status:"Approved" },
  { id:7, member:"Taylor Schenher", project:"Finance", task:"Q1 revenue forecast model", hours:6, date:"2026-02-07", status:"Submitted" },
  { id:8, member:"Taylor Schenher", project:"Finance", task:"Q4 reconciliation review", hours:4, date:"2026-02-06", status:"Approved" },
  { id:9, member:"Lucas Mason", project:"Sales", task:"Product demos (2)", hours:4, date:"2026-02-07", status:"Submitted" },
  { id:10, member:"Lucas Mason", project:"Canstorr Phase 2", task:"Proposal preparation", hours:3, date:"2026-02-07", status:"Submitted" },
  { id:11, member:"Lucas Mason", project:"Sales", task:"Email campaign setup", hours:3, date:"2026-02-06", status:"Approved" },
  { id:12, member:"Des Bachynski", project:"VitaSync Launch", task:"Staff training session", hours:5, date:"2026-02-07", status:"Submitted" },
  { id:13, member:"Des Bachynski", project:"VitaSync Launch", task:"Compliance documentation", hours:3, date:"2026-02-06", status:"Approved" },
  { id:14, member:"Lee Mehling", project:"Mining Sector Expansion", task:"Western Mining demo", hours:4, date:"2026-02-07", status:"Submitted" },
  { id:15, member:"Lee Mehling", project:"Mining Sector Expansion", task:"Compliance research", hours:4, date:"2026-02-06", status:"Approved" },
  { id:16, member:"Clorice Robertson", project:"Finance", task:"AR reconciliation", hours:6, date:"2026-02-07", status:"Submitted" },
  { id:17, member:"Clorice Robertson", project:"Finance", task:"Expense report processing", hours:3, date:"2026-02-06", status:"Approved" },
  { id:18, member:"Tyson Becker", project:"Canstorr Phase 2", task:"Quarterly review meeting", hours:4, date:"2026-02-07", status:"Submitted" },
  { id:19, member:"Tyson Becker", project:"CropPatrol", task:"Sensor installation - AgriTech", hours:6, date:"2026-02-06", status:"Approved" },
  { id:20, member:"Tyler Hodgson", project:"Platform", task:"Overwatch dashboard enhancements", hours:5, date:"2026-02-07", status:"Submitted" }
];

const TEAM = ["All","Jordan Lutz","Ryan Miskulin","Taylor Schenher","Lucas Mason","Des Bachynski","Lee Mehling","Clorice Robertson","Tyson Becker","Tyler Hodgson"];
const STATUS_OPTIONS = ["All","Submitted","Approved","Rejected"];

export default function TimeTrackingPage() {
  const [entries, setEntries] = useState(TIME_ENTRIES);
  const [memberFilter, setMemberFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [view, setView] = useState("table");

  const filtered = entries.filter(e => {
    if (memberFilter !== "All" && e.member !== memberFilter) return false;
    if (statusFilter !== "All" && e.status !== statusFilter) return false;
    return true;
  });

  const totalHours = filtered.reduce((sum, e) => sum + e.hours, 0);
  const avgPerDay = (totalHours / 5).toFixed(1);
  const billableHours = Math.round(totalHours * 0.78);
  const overtime = filtered.filter(e => e.hours > 8).length;

  const approveEntry = (id) => {
    setEntries(prev => prev.map(e => e.id === id ? { ...e, status: "Approved" } : e));
  };

  const rejectEntry = (id) => {
    setEntries(prev => prev.map(e => e.id === id ? { ...e, status: "Rejected" } : e));
  };

  const statusBadge = (status) => {
    const map = { Submitted:"badge badge-yellow", Approved:"badge badge-green", Rejected:"badge badge-red" };
    return map[status] || "badge";
  };

  // Group by member for summary
  const memberSummary = TEAM.slice(1).map(name => {
    const memberEntries = entries.filter(e => e.member === name);
    return {
      name,
      totalHours: memberEntries.reduce((sum, e) => sum + e.hours, 0),
      entries: memberEntries.length,
      submitted: memberEntries.filter(e => e.status === "Submitted").length,
      approved: memberEntries.filter(e => e.status === "Approved").length
    };
  });

  // Group by project for summary
  const projectSummary = [...new Set(entries.map(e => e.project))].map(proj => ({
    project: proj,
    hours: entries.filter(e => e.project === proj).reduce((sum, e) => sum + e.hours, 0)
  })).sort((a, b) => b.hours - a.hours);

  return (
    <div>
      <div className="page-header">
        <div><h1 className="page-title">Time Tracking</h1><p>Team timesheet management</p></div>
        <div style={{display:"flex",gap:8}}>
          <button className={"btn "+(view==="table"?"btn-primary":"btn-outline")} onClick={() => setView("table")}>Entries</button>
          <button className={"btn "+(view==="summary"?"btn-primary":"btn-outline")} onClick={() => setView("summary")}>Summary</button>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card"><div className="stat-label">Total Hours This Week</div><div className="stat-value">{totalHours}</div></div>
        <div className="stat-card"><div className="stat-label">Avg Hours/Day</div><div className="stat-value">{avgPerDay}</div></div>
        <div className="stat-card"><div className="stat-label">Billable %</div><div className="stat-value" style={{color:"#10b981"}}>78%</div></div>
        <div className="stat-card"><div className="stat-label">Overtime Entries</div><div className="stat-value" style={{color:overtime>0?"#eab308":"#64748b"}}>{overtime}</div></div>
      </div>

      <div style={{display:"flex",gap:12,marginBottom:16}}>
        <select className="input" value={memberFilter} onChange={e => setMemberFilter(e.target.value)} style={{width:200}}>
          {TEAM.map(t => <option key={t} value={t}>{t === "All" ? "All Team Members" : t}</option>)}
        </select>
        <select className="input" value={statusFilter} onChange={e => setStatusFilter(e.target.value)} style={{width:160}}>
          {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s === "All" ? "All Statuses" : s}</option>)}
        </select>
      </div>

      {view === "table" ? (
        <div className="card">
          <div className="card-header"><h3>Time Entries</h3><span style={{fontSize:12,color:"#64748b"}}>{filtered.length} entries | {totalHours} hours</span></div>
          <div style={{overflowX:"auto"}}>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead>
                <tr style={{borderBottom:"2px solid #334155"}}>
                  {["Team Member","Project","Task","Hours","Date","Status","Actions"].map(h => (
                    <th key={h} style={{textAlign:"left",padding:"10px 8px",fontSize:12,fontWeight:700,color:"#94a3b8"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(e => (
                  <tr key={e.id} style={{borderBottom:"1px solid #334155"}}>
                    <td style={{padding:"10px 8px",fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{e.member}</td>
                    <td style={{padding:"10px 8px",fontSize:12,color:"#94a3b8"}}>{e.project}</td>
                    <td style={{padding:"10px 8px",fontSize:12,color:"#e2e8f0"}}>{e.task}</td>
                    <td style={{padding:"10px 8px",fontSize:13,fontWeight:700,color:"#10b981"}}>{e.hours}h</td>
                    <td style={{padding:"10px 8px",fontSize:12,color:"#94a3b8"}}>{e.date}</td>
                    <td style={{padding:"10px 8px"}}><span className={statusBadge(e.status)}>{e.status}</span></td>
                    <td style={{padding:"10px 8px"}}>
                      {e.status === "Submitted" && (
                        <div style={{display:"flex",gap:4}}>
                          <button className="btn btn-sm btn-primary" onClick={() => approveEntry(e.id)}>Approve</button>
                          <button className="btn btn-sm btn-outline" onClick={() => rejectEntry(e.id)}>Reject</button>
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div>
          <div className="card">
            <div className="card-header"><h3>Hours by Team Member</h3></div>
            <table style={{width:"100%",borderCollapse:"collapse"}}>
              <thead>
                <tr style={{borderBottom:"2px solid #334155"}}>
                  {["Member","Total Hours","Entries","Submitted","Approved"].map(h => (
                    <th key={h} style={{textAlign:"left",padding:"10px 8px",fontSize:12,fontWeight:700,color:"#94a3b8"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {memberSummary.map(m => (
                  <tr key={m.name} style={{borderBottom:"1px solid #334155"}}>
                    <td style={{padding:"10px 8px",fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{m.name}</td>
                    <td style={{padding:"10px 8px",fontSize:13,fontWeight:700,color:"#10b981"}}>{m.totalHours}h</td>
                    <td style={{padding:"10px 8px",fontSize:12,color:"#94a3b8"}}>{m.entries}</td>
                    <td style={{padding:"10px 8px",fontSize:12,color:"#eab308"}}>{m.submitted}</td>
                    <td style={{padding:"10px 8px",fontSize:12,color:"#10b981"}}>{m.approved}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="card" style={{marginTop:16}}>
            <div className="card-header"><h3>Hours by Project</h3></div>
            <div className="chart-bar-container">
              {projectSummary.map(p => (
                <div key={p.project} className="chart-bar-row">
                  <span className="chart-bar-label" style={{width:180}}>{p.project}</span>
                  <div className="chart-bar-track"><div className="chart-bar-fill" style={{width:(p.hours / Math.max(...projectSummary.map(x => x.hours)) * 100)+"%"}}>{p.hours}h</div></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Weekly Grid */}
      <div className="card" style={{marginTop:16}}>
        <div className="card-header"><h3>Weekly Grid - Feb 3-7, 2026</h3></div>
        <div style={{overflowX:"auto"}}>
          <table style={{width:"100%",borderCollapse:"collapse"}}>
            <thead>
              <tr style={{borderBottom:"2px solid #334155"}}>
                <th style={{textAlign:"left",padding:"10px 8px",fontSize:12,fontWeight:700,color:"#94a3b8"}}>Member</th>
                {["Mon","Tue","Wed","Thu","Fri"].map(d => <th key={d} style={{textAlign:"center",padding:"10px 8px",fontSize:12,fontWeight:700,color:"#94a3b8"}}>{d}</th>)}
                <th style={{textAlign:"center",padding:"10px 8px",fontSize:12,fontWeight:700,color:"#10b981"}}>Total</th>
              </tr>
            </thead>
            <tbody>
              {TEAM.slice(1).map(name => {
                const daily = [8,8.5,9,8,8.5].map((v,i) => i < 2 ? v : (Math.random()*3+6).toFixed(1));
                const total = daily.reduce((s,v) => s + parseFloat(v), 0).toFixed(1);
                return (
                  <tr key={name} style={{borderBottom:"1px solid #334155"}}>
                    <td style={{padding:"10px 8px",fontSize:13,fontWeight:600,color:"#e2e8f0"}}>{name}</td>
                    {daily.map((d, i) => (
                      <td key={i} style={{textAlign:"center",padding:"10px 8px",fontSize:13,color:parseFloat(d) > 8?"#eab308":"#e2e8f0"}}>{d}</td>
                    ))}
                    <td style={{textAlign:"center",padding:"10px 8px",fontSize:13,fontWeight:700,color:"#10b981"}}>{total}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
